module.exports = __webpack_public_path__ + "media/images/marketing/step3-db00227d77c34dfca0c081ade38c5870478a4915004bf1b55af0c7a27dc742db.jpg";